module.exports = __webpack_public_path__ + "img/tabs1(1).a100ff80.png";